import { httpClient } from 'api/clients/httpClient'
import { CurrentAccount, Organization, OrganizationDTO } from 'types/Organization'

export const getCurrentAccount = async (): Promise<CurrentAccount> => {
    try {
        const { data } = await httpClient.get('/accounts/current')
        return data
    } catch (error: any) {
        throw new Error(`Failed to get account: ${error.response?.data?.message}`)
    }
}

export const createOrganization = async (userData: OrganizationDTO): Promise<any> => {
    try {
        const { data } = await httpClient.post('/accounts/create', { userData })
        return data
    } catch (error: any) {
        throw new Error(`Failed to create organization: ${error.response?.data?.message}`)
    }
}

export const updateOrganization = async (orgId: string, organizationData: OrganizationDTO): Promise<any> => {
    try {
        const { data } = await httpClient.put(`/accounts/update/${orgId}`, { organizationData })
        return data
    } catch (error) {
        throw new Error('Failed to update organization')
    }
}

export const getOrganizations = async (searchTerm = ''): Promise<Organization[]> => {
    const { data } = await httpClient.get('/accounts/orgs', {
        params: {
            search: searchTerm,
        },
    })

    return data
}

export const removeUserAndOrganization = async (orgId: string): Promise<Organization[]> => {
    const { data } = await httpClient.delete(`/accounts/remove/${orgId}`)

    return data
}
